__turbopack_context__.v({
  "blue": "Panel-module__qcQMWW__blue",
  "homeSecurityDifference": "Panel-module__qcQMWW__homeSecurityDifference",
  "orange": "Panel-module__qcQMWW__orange",
  "panel": "Panel-module__qcQMWW__panel",
  "title": "Panel-module__qcQMWW__title",
  "vcaIntro": "Panel-module__qcQMWW__vcaIntro",
  "well": "Panel-module__qcQMWW__well",
});
